import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, LargeStateButton } from './common';
import { HeadLine, Caption1 } from './Typography';
import SvgIcon from './SvgIcon';

const ButtonWrapper = styled(LargeStateButton)`
  display: flex;
  position: relative;
`;

const TextContaier = styled(Box)`
  position: absolute;
  bottom: 12px;
  height: 38px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

function SelectorButton(props) {
  const {
    icon,
    title,
    subtitle,
    selected,
    size,
    iconColor,
    ...restProps
  } = props;

  let paddings = {};
  if (subtitle) {
    paddings.pb = 12;
  }

  const iconProps = {
    width: size || 48,
    height: size || 48,
    color: selected ? 'white' : iconColor,
    fill: selected ? 'white' : iconColor
  };

  const titleColor = selected ? 'white' : undefined;

  return (
    <ButtonWrapper selected={selected} {...restProps} {...paddings}>
      <Box
        flex={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={5}
      >
        <SvgIcon name={icon} {...iconProps} />
      </Box>
      <TextContaier>
        {title && <HeadLine color={titleColor}>{title}</HeadLine>}
        {subtitle && <Caption1 color={titleColor}>{subtitle}</Caption1>}
      </TextContaier>
    </ButtonWrapper>
  );
}

SelectorButton.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  selected: PropTypes.bool,
  size: PropTypes.number,
  iconColor: PropTypes.string
};

SelectorButton.defaultProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flex: 1,
  alignItems: 'center'
};

export default SelectorButton;
